import { render, staticRenderFns } from "./FormCheckbox.vue?vue&type=template&id=2b048a3d&scoped=true"
import script from "./FormCheckbox.vue?vue&type=script&lang=ts"
export * from "./FormCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./FormCheckbox.vue?vue&type=style&index=0&id=2b048a3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b048a3d",
  null
  
)

export default component.exports